<mat-panel-description [ngClass]="statusClass">
  <mat-icon class="valid">check</mat-icon>
  <mat-icon class="invalid">error_outline</mat-icon>
  <ng-content></ng-content>
</mat-panel-description>
